import React, {useState} from 'react';
import {IdleTimeOutModal} from "../IdleTimeOutModal/IdleTimeOutModal";
import IdleTimer from "react-idle-timer";
import {logout, checkAuthentication, getOktaStorageToken} from "../../shared/okta.helper";

export const IdleTimeOut = ({disabled=false}) => {

    const idleResponseTimeOut = 30;
    const idleTimeOut = 900000; //1000 * 60 * 15
    const [showModal, setShowModal] = useState(false);
    const [remainingTime, setRemainingTime] = useState(idleResponseTimeOut);
    const [remainingTimeInterval, setRemainingTimeInterval] = useState(null);

    const handleOnIdle = (e) => {
        const interval = setInterval(decreaseRemainingTime, 1000);
        setRemainingTimeInterval(interval);
        setShowModal(true);
    }

    const decreaseRemainingTime = () => {
        setRemainingTime(prev => {
            const val = prev - 1;
            if(val === 0) {
                window.onbeforeunload = event => null
                handleLogout();
            }
            return  val;
        });
    }

    const acceptedStringArray = () => {
        // moment.js doesn't return in integer so this array needs to be populated once.
    let stringArray = ['in seconds','in a minute'];
    for(let i=2; i<=16; i++) {
        stringArray.push(`in ${i} minutes`);
    }
    return stringArray;
    }

    const handleAction = e => {
        // if the user is active in the last 14 minutes of the 1hr session token, then refresh the token (+1hr)
        const expiresAt = getOktaStorageToken() ?? getOktaStorageToken().idToken.expiresAt;
        const timeFromNow = window.moment.unix(expiresAt).fromNow();
        acceptedStringArray().includes(timeFromNow) ??
            checkAuthentication();
    }

    const handleClose = () => {
        clearInterval(remainingTimeInterval);
        checkAuthentication();
        setShowModal(false);
        setRemainingTime(idleResponseTimeOut);
    }

    const handleLogout = () => {
        logout();
    }

   return (
       <> 
            { !disabled &&
                <>
                    <IdleTimeOutModal
                        showModal={showModal}
                        handleClose={handleClose}
                        remainingTime={remainingTime}
                    />
                    <IdleTimer
                        onIdle={handleOnIdle}
                        debounce={250}
                        timeout={idleTimeOut}
                        onAction={handleAction}
                    />
                </>
            }
       </>
   );
}